module.exports = __webpack_public_path__ + "media/images/shapes/angles/angle-top-7ebc86a3c3ca184481ddc6ef79cd60a1b0c30fd4ba9523a4cbe2ebbfa29d712b.svg";